import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Switch } from 'react-router-dom';
import { TinyButton as ScrollUpButton } from 'react-scroll-up-button';

import CredentialsHelper from '../../utils/credentials-helper';
import { fetchAppData } from '../app/app.actions';
import Header from '../header/header';
import Footer from '../footer/footer';
import Notifications from '../notifications/notifications';
import CoachPagesContainer from './components/coach-pages/coach-pages';
import LoginRedirect from '../commons/login-redirect';

class InternalPages extends React.Component {

    componentDidMount() {
        if (CredentialsHelper.isLoggedIn) {
            this.props.fetchAppData();
        }
    }

    render() {
        if (!CredentialsHelper.isLoggedIn) {
            return <LoginRedirect/>;
        }
        return (
            <div className='app-wrapper'>
                <Header {...this.props}/>
                <Switch>
                    <CoachPagesContainer {...this.props}/>
                </Switch>
                <Footer/>
                <Notifications/>
                <ScrollUpButton style={{
                    backgroundColor: '#1da4fc',
                    padding: '5px',
                    fill: 'white',
                    boxShadow: '-2px 2px 1px 0 rgba(0, 0, 0, 0.5)',
                    borderRadius: '5px',
                }}/>
            </div>
        );
    }
}

export default connect(
    null,
    dispatch => bindActionCreators({ fetchAppData }, dispatch),
)(InternalPages);



// WEBPACK FOOTER //
// ./src/components/internal-pages/internal-pages.js